<template>
  <div class="p-3 mb-2 mt-4 mx-lg-5 mx-md-2 mx-sm-2 rounded-8">
    <div class="d-flex justify-content-between mb-3">
      <h4><strong style="color:#1A0054">Rutas</strong></h4>
    </div>
    
    <div class="table-responsive rounded-8">
      <table class="table table-borderer text-table-normal">
        <thead class="bg-table-normal-header text-white">
          <tr>
            <th class="p-3">No.</th>
            <th class="p-3">Nombre de la ruta</th>
            <th class="p-3">Tipo</th>
            <th class="p-3">Estado</th>
            <th class="p-3">Inicio</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="loading">
            <td colspan="5" class="text-center">
              <div class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Cargando...</span>
              </div>
            </td>
          </tr>
          
          <tr v-else-if="routes.length === 0">
            <td colspan="5" class="text-center">
              <p class="mb-0">El usuario no tiene rutas asignadas.</p>
            </td>
          </tr>
          
          <tr v-else v-for="route in routes" :key="route.id">
            <td>{{ route.id }}</td>
            <td>{{ route.name }}</td>
            <td>{{ route.tipoRuta || '-' }}</td>
            <td>
              <span 
                :class="getStatusClass(route.estadoUsuario)"
                class="badge"
              >
                {{ route.estadoUsuario || 'Sin estado' }}
              </span>
            </td>
            <td>{{ formatDate(route.asignacion_ruta) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StudentRoutesSection',
  
  props: {
    routes: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false }
  },

  methods: {
    getStatusClass(status) {
      const statusMap = {
        'En progreso': 'bg-warning',
        'Aprobada': 'bg-success',
        'Fallida': 'bg-danger'
      }
      return statusMap[status] || 'bg-secondary'
    },

    formatDate(date) {
      if (!date) return '-'
      try {
        return new Date(date).toLocaleDateString('es-ES')
      } catch {
        return date
      }
    }
  }
}
</script>

<style scoped>
.text-table-normal {
  font-size: 12px;
  color: #1A0054;
}

.bg-table-normal-header {
  background-color: #5A1FE0;
}
</style>